export default __webpack_public_path__ + "static/media/cvod-R13.336a3090.svg";